import * as React from 'react';
import * as ReactDOM from 'react-dom';
import App from './App';
import { BrowserRouter } from 'react-router-dom';
import { Provider } from 'react-redux';
import { createStore } from 'redux';

import * as ReactGA from "react-ga";

ReactGA.initialize('UA-73235834-8');
ReactGA.pageview(window.location.pathname + window.location.search);

const store = createStore(App)

ReactDOM.render((
  <Provider store={store} >
    <BrowserRouter>
      <App />
    </BrowserRouter>
  </Provider>
), document.getElementById('root'))


// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/index.tsx